document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-faq-group]').forEach((group) => {
    const items = Array.from(group.querySelectorAll('details'));

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        items.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });
  });

  document.querySelectorAll('[data-celestial-signature]').forEach((signature) => {
    const mark = signature.querySelector('.cart-items__signature-mark');
    const source = signature.dataset.celestialSignature || 'NOVILUNAR';
    if (!mark || mark.querySelector('svg')) return;

    let seed = 2166136261;
    for (let index = 0; index < source.length; index += 1) {
      seed ^= source.charCodeAt(index);
      seed = Math.imul(seed, 16777619);
    }

    const random = () => {
      seed += 0x6D2B79F5;
      let value = seed;
      value = Math.imul(value ^ (value >>> 15), value | 1);
      value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
      return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
    };

    const pointCount = 5;
    const regions = [
      [10, 8, 23, 12],
      [31, 4, 45, 13],
      [49, 15, 61, 27],
      [65, 5, 78, 15],
      [72, 19, 86, 28]
    ];
    const points = regions.map(([minX, minY, maxX, maxY]) => ({
      x: minX + (random() * (maxX - minX)),
      y: minY + (random() * (maxY - minY)),
      radius: 1.8 + (random() * 1.1)
    }));
    const connections = [];

    for (let index = 1; index < pointCount; index += 1) {
      connections.push([index, Math.floor(random() * index)]);
    }

    const extraStart = Math.floor(random() * pointCount);
    let extraEnd = Math.floor(random() * pointCount);
    if (extraEnd === extraStart) extraEnd = (extraEnd + 2) % pointCount;
    connections.push([extraStart, extraEnd]);
    const namespace = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(namespace, 'svg');
    svg.setAttribute('viewBox', '0 0 90 32');

    connections.forEach(([startIndex, endIndex]) => {
      const line = document.createElementNS(namespace, 'line');
      line.setAttribute('x1', points[startIndex].x.toFixed(2));
      line.setAttribute('y1', points[startIndex].y.toFixed(2));
      line.setAttribute('x2', points[endIndex].x.toFixed(2));
      line.setAttribute('y2', points[endIndex].y.toFixed(2));
      svg.appendChild(line);
    });

    points.forEach((point) => {
      const star = document.createElementNS(namespace, 'circle');
      star.setAttribute('cx', point.x.toFixed(2));
      star.setAttribute('cy', point.y.toFixed(2));
      star.setAttribute('r', point.radius.toFixed(2));
      svg.appendChild(star);
    });

    mark.appendChild(svg);
  });

  document.querySelectorAll('.natal-storefront').forEach((storefront) => {
    const orbitCenter = storefront.querySelector('.natal-order__grid > div:last-child');
    if (!orbitCenter || !window.matchMedia('(pointer: fine)').matches) return;

    let pointerFrame;

    const settleEdge = () => {
      storefront.classList.remove('is-orbit-active');
      storefront.style.setProperty('--orbit-pull-x', '0px');
      storefront.style.setProperty('--orbit-pull-y', '0px');
      storefront.style.setProperty('--orbit-edge-alpha', '0.24');
    };

    const settleOrbit = () => {
      settleEdge();
      storefront.classList.remove('is-orbit-inside');
    };

    storefront.addEventListener('pointermove', (event) => {
      if (pointerFrame) window.cancelAnimationFrame(pointerFrame);

      pointerFrame = window.requestAnimationFrame(() => {
        const centerRect = orbitCenter.getBoundingClientRect();
        const centerX = centerRect.left + (centerRect.width / 2);
        const centerY = centerRect.top + (centerRect.height / 2);
        const deltaX = event.clientX - centerX;
        const deltaY = event.clientY - centerY;
        const distance = Math.hypot(deltaX, deltaY);
        const radius = Math.min(500, (window.innerWidth - 48) / 2);
        const edgeDistance = Math.abs(distance - radius);
        const influence = Math.max(0, 1 - (edgeDistance / 120));
        storefront.classList.toggle('is-orbit-inside', distance <= radius);

        if (influence <= 0) {
          settleEdge();
          return;
        }

        const directionX = distance ? deltaX / distance : 0;
        const directionY = distance ? deltaY / distance : 0;
        storefront.classList.add('is-orbit-active');
        storefront.style.setProperty('--orbit-pull-x', `${(directionX * influence * 14).toFixed(2)}px`);
        storefront.style.setProperty('--orbit-pull-y', `${(directionY * influence * 14).toFixed(2)}px`);
        storefront.style.setProperty('--orbit-edge-alpha', (0.24 + (influence * 0.34)).toFixed(2));
      });
    });

    storefront.addEventListener('pointerleave', settleOrbit);
  });

  document.querySelectorAll('[data-birth-form]').forEach((form) => {
    const unknownToggle = form.querySelector('[data-time-unknown]');
    const timeInput = form.querySelector('[data-birth-time]');
    const knownInput = form.querySelector('[data-time-known-value]');

    form.querySelectorAll('.natal-field input:not([type="hidden"]), .natal-field textarea').forEach((fieldInput) => {
      const field = fieldInput.closest('.natal-field');
      if (!field) return;

      const syncFieldState = () => field.classList.toggle('is-complete', fieldInput.value.trim().length > 0);
      fieldInput.addEventListener('focus', () => field.classList.add('is-active'));
      fieldInput.addEventListener('blur', () => field.classList.remove('is-active'));
      fieldInput.addEventListener('input', syncFieldState);
      fieldInput.addEventListener('change', syncFieldState);
      syncFieldState();
    });

    if (unknownToggle && timeInput && knownInput) {
      const syncBirthTime = () => {
        const isUnknown = unknownToggle.checked;
        if (isUnknown && timeInput.value) timeInput.dataset.previousValue = timeInput.value;
        if (isUnknown) timeInput.value = '';
        if (!isUnknown && !timeInput.value && timeInput.dataset.previousValue) {
          timeInput.value = timeInput.dataset.previousValue;
        }
        timeInput.disabled = isUnknown;
        timeInput.required = !isUnknown;
        timeInput.setAttribute('aria-disabled', isUnknown ? 'true' : 'false');
        knownInput.value = isUnknown ? 'No' : 'Yes';
        timeInput.closest('.natal-field').classList.toggle('is-disabled', isUnknown);
        timeInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      unknownToggle.addEventListener('change', syncBirthTime);
      syncBirthTime();
    }

    const submitButton = form.querySelector('.natal-submit');
    const errorNote = form.querySelector('[data-birth-form-error]');
    const nameInput = form.querySelector('input[name="properties[Full name]"]');
    const dateInput = form.querySelector('input[name="properties[Birth date]"]');
    const countryInput = form.querySelector('[data-birth-country]');
    const productAvailable = submitButton?.dataset.productAvailable === 'true';
    const readyLabel = submitButton?.dataset.readyLabel || 'Create my book';
    const incompleteLabel = submitButton?.dataset.incompleteLabel || 'Complete your details';
    const root = () => window.Shopify?.routes?.root || '/';

    const syncNameValidity = () => {
      if (!nameInput) return;
      nameInput.setCustomValidity(nameInput.value.trim() ? '' : 'Enter your full name.');
    };

    let dateError;
    if (dateInput) {
      dateError = document.createElement('p');
      dateError.className = 'natal-field-error';
      dateError.id = `${dateInput.id || 'NatalBirthDate'}-error`;
      dateError.hidden = true;
      dateError.dataset.dateError = '';
      dateInput.insertAdjacentElement('afterend', dateError);
      dateInput.setAttribute('aria-describedby', dateError.id);

      const markDateTouched = () => {
        dateInput.dataset.touched = 'true';
        syncSubmitState();
      };
      dateInput.addEventListener('change', markDateTouched);
      dateInput.addEventListener('blur', markDateTouched);
    }

    const syncDateError = () => {
      if (!dateInput || !dateError) return;
      const showError = dateInput.dataset.touched === 'true' && !dateInput.validity.valid;
      let message = '';

      if (showError) {
        if (dateInput.validity.valueMissing) message = 'Enter your birth date.';
        else if (dateInput.validity.rangeUnderflow) message = 'Birth date must be 1900 or later.';
        else if (dateInput.validity.rangeOverflow) message = 'Birth date cannot be in the future.';
        else message = 'Enter a valid birth date.';
      }

      dateError.textContent = message;
      dateError.hidden = !showError;
      if (showError) dateInput.setAttribute('aria-invalid', 'true');
      else dateInput.removeAttribute('aria-invalid');
    };

    const syncSubmitState = () => {
      if (!submitButton || form.dataset.submitting === 'true') return;
      syncNameValidity();
      syncDateError();
      const ready = productAvailable
        && form.dataset.locationResolved === 'true'
        && form.checkValidity();
      submitButton.disabled = !ready;
      submitButton.setAttribute('aria-disabled', ready ? 'false' : 'true');

      let buttonLabel = incompleteLabel;
      if (!nameInput?.validity.valid) buttonLabel = 'Enter your full name';
      else if (dateInput?.validity.valueMissing) buttonLabel = 'Enter your birth date';
      else if (dateInput && !dateInput.validity.valid) buttonLabel = 'Check your birth date';
      else if (timeInput && !timeInput.disabled && !timeInput.validity.valid) {
        buttonLabel = 'Enter birth time or choose unknown';
      } else if (!countryInput?.validity.valid) buttonLabel = 'Select your birth country';
      else if (form.dataset.locationResolved !== 'true') buttonLabel = 'Confirm your birth city';

      submitButton.textContent = productAvailable
        ? (ready ? readyLabel : buttonLabel)
        : 'Book unavailable';
    };

    form.addEventListener('input', syncSubmitState);
    form.addEventListener('change', syncSubmitState);
    form.addEventListener('locationchange', syncSubmitState);
    syncSubmitState();

    form.addEventListener('submit', async (event) => {
      if (form.dataset.submitting === 'true') return;
      event.preventDefault();

      syncNameValidity();
      const cityInput = form.querySelector('[data-birth-city]');
      if (cityInput && form.dataset.locationResolved !== 'true') {
        cityInput.setCustomValidity('Choose your birth city from the suggestions.');
        cityInput.reportValidity();
        cityInput.focus();
        return;
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      form.dataset.submitting = 'true';

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
        submitButton.textContent = 'Adding your book…';
      }

      if (errorNote) {
        errorNote.textContent = '';
        errorNote.hidden = true;
      }

      try {
        const response = await fetch(`${root()}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        // Shopify returns the reason for a rejected line in the body.
        const payload = await response.json().catch(() => null);

        if (!response.ok) {
          throw new Error(payload?.description || payload?.message || 'Your book could not be added to the cart.');
        }

        // The button stays disabled through navigation so it cannot be
        // submitted twice while the next page loads.
        window.location.assign(`${root()}cart`);
      } catch (error) {
        form.dataset.submitting = 'false';

        if (submitButton) {
          submitButton.removeAttribute('aria-busy');
        }

        syncSubmitState();

        if (errorNote) {
          errorNote.textContent = error?.message || 'Your book could not be added to the cart.';
          errorNote.hidden = false;
        }

        submitButton?.focus();
      }
    });

  });
});
